import { Button, IconTrash, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { addExcludedContentToQuery } from 'utils/collection';

interface ExcludeFromQueryProps {
  jsonQueryStr: string;
  allessehContent: AllessehContent;
  setJsonQueryStr: (newQueryStr: string) => void;
  disabled?: boolean;
}

export const ExcludeFromQuery = ({
  jsonQueryStr,
  allessehContent,
  setJsonQueryStr,
  disabled = false
}: ExcludeFromQueryProps) => {
  const handleExclude = () => {
    if (jsonQueryStr) {
      const parsedJsonQuery = addExcludedContentToQuery(allessehContent.data.id, jsonQueryStr);
      setJsonQueryStr(JSON.stringify(parsedJsonQuery));
    }
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button
          tertiary
          icon={IconTrash}
          color="lava"
          onClick={handleExclude}
          disabled={disabled}
          data-testid="page-content-card-exclude-query-button"
        >
          Exclude from Query
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
